<template>
	<mdb-col v-bind="colBind">
		<mdb-row>
			<edit-table ref="table" class="my-1 mr-2" :columns="columns" :data="data" :current-page="page" @page="changePage" @delete="deleteProperty" @update="updateProperty">
				<template v-slot:__path="{ field, row, index, value }">
					<path-input :value="value" @change="change({ field, row, index, value: $event })"></path-input>
				</template>
			</edit-table>
		</mdb-row>
	</mdb-col>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mdbBtn } from '@/components/mdbvue'

import EditTable from '@/components/common/EditTable'
import PathInput from '@/components/common/PathInput'

export default {
	name: 'Edit',
	components: { mdbBtn, PathInput, EditTable },
	props: { col: String | Object },
	data () {
		return {
			page: 0
		}
	},
	computed: {
		columns () {
			return [
				{
					label: 'Name',
					field: 'name',
					sort: 'asc'
				},
				{
					label: 'Path',
					field: 'path'
				}
			]
		},
		data () {
			return Object.values(this.properties.all)
		},
		colBind () {
			if (!this.col) {
				return {}
			} else if (this.col.constructor === Object) {
				return this.col
			} else {
				return { col: this.col }
			}
		},
		...mapState('properties', ['properties'])
	},
	methods: {
		change ({ field, row, index, value }) {
			this.$refs.table.change({ field, row, index, value })
		},
		changePage (page) {
			this.page = page
		},
		...mapActions('properties', ['updateProperty', 'deleteProperty'])
	}
}
</script>

<style scoped>

</style>
